import SectionLink from "@components/LeftMenu/SectionLink";
import SectionMenuSuportLink from "@components/LeftMenu/SectionMenuSuporteLink/SectionMenuSuporteLink";
import SectionTitle from "@components/LeftMenu/SectionTitle";
import {routeCodes} from "@constants/routes";
import {titleConstants} from "@constants/SuporteConstants/geral";
import classNames from "classnames";
import React from "react";
import {useLocation} from "react-router-dom";
import "./MenuSuporte.scss";

function MenuSuporte() {
  const location = useLocation();
  const isActive = (value) => {
    if (location.pathname === value) return true;
    return false;
  };

  const isSuporteMainRoute = (value) => {
    if (location.pathname.includes(value)) return true;
    return false;
  };

  return (
    <React.Fragment>
      <h4 className="navigation-section-title-sm purple-text bold small-only">Suporte</h4>

      <SectionTitle
        title="Suporte"
        className="navigation-section-title purple-text bold uppercase large-only"
      />

      <SectionLink
        title={titleConstants.AJUDA_TITLE}
        link={routeCodes.SUPORTE_AJUDA}
        className={classNames({
          "navigation-section-link": true,
          "purple-text": true,
          bold: true,
          "mt-5": true,
          active: isSuporteMainRoute(routeCodes.SUPORTE_AJUDA),
        })}
      />
      <div className="left-bar">
        <div className="left-menu-suporte-sublinks">
          <SectionMenuSuportLink
            title={titleConstants.GERAL_TITLE}
            link={routeCodes.SUPORTE_GERAL}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_GERAL),
            })}
          />
          <SectionMenuSuportLink
            title={titleConstants.NAVEGACAO_TITLE}
            link={routeCodes.SUPORTE_NAVEGACAO}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_NAVEGACAO),
            })}
          />
          <SectionMenuSuportLink
            title={titleConstants.ALERTAS_MONITORAMENTO_TITLE}
            link={routeCodes.SUPORTE_ALERTA_MONITORAMENTO}
            className={classNames({
              "navigation-section-suport-link": true,
              "navigation-section-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_ALERTA_MONITORAMENTO),
            })}
          />
          <SectionMenuSuportLink
            title={titleConstants.BUSCAR_TERMOS_TITLE}
            link={routeCodes.SUPORTE_TERMOS_PROCESSOS}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_TERMOS_PROCESSOS),
            })}
          />
          {/* <SectionMenuSuportLink
            title="Acompanhar licitação"
            link={routeCodes.SUPORTE_ACOMPANHAR_LICITACAO}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_ACOMPANHAR_LICITACAO),
            })}
          /> */}
          <SectionMenuSuportLink
            title={titleConstants.ASSINATURAS_TITLE}
            link={routeCodes.SUPORTE_ASSINATURAS}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_ASSINATURAS),
            })}
          />
          <SectionMenuSuportLink
            title={titleConstants.SUPORTE_PAGAMENTOS_TITLE}
            link={routeCodes.SUPORTE_PAGAMENTOS}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_PAGAMENTOS),
            })}
          />
          <SectionMenuSuportLink
            title={titleConstants.SUPORTE_TITLE}
            link={routeCodes.SUPORTE_SUPORTE}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-suport-link": true,
              bold: true,
              active: isActive(routeCodes.SUPORTE_SUPORTE),
            })}
          />
        </div>
      </div>
      <SectionLink
        title={titleConstants.RELATAR_ERRO_OU_DUVIDA_TITLE}
        link={routeCodes.SUPORTE_RELATAR_ERRO}
        className={classNames({
          "navigation-section-link": true,
          "purple-text": true,
          bold: true,
          "my-3": true,
          active: isActive(routeCodes.SUPORTE_RELATAR_ERRO),
        })}
      />
    </React.Fragment>
  );
}

export default MenuSuporte;
